import React from 'react';
import { withStyles } from '@material-ui/core/styles';

import Avatar from '@material-ui/core/Avatar';
import Popper from '@material-ui/core/Popper';
import Paper from '@material-ui/core/Paper';
import Typography from '@material-ui/core/Typography';

const styles = theme => ({
  candidatoChart: {
    display: 'flex',
    padding: '5px 16px 5px 16px',
    alignItems: 'center',
  },
  candidatoBar: {
    height: '20px',
    transition: 'width 0.5s',
    textAlign: 'right',
    lineHeight: '20px',
    fontWeight: 'bold',
    borderRadius: '0 5px 5px 0',
    border: '1px solid black',
  },
  candidatoBarRejeicao: {
    position: 'absolute',
    height: '20px',
    lineHeight: '20px',
    fontWeight: 'bold',
    transition: 'width 0.5s',
    right: '0',
    bottom: '0',
    border: 'solid 1px',
    borderRadius: '5px 0 0 5px',
    background:
      'url(data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAYAAAAGCAYAAADgzO9IAAAAKElEQVQYV2NkwA7+M2IR/8/AwMCILgEWBClGloALIkugCMIkMARBEgC7IAYGchlNYwAAAABJRU5ErkJggg==) repeat',
  },
});

class MajoritarioPopper extends React.Component {
  render() {
    let { candidato, classes, anchorEl, path, open, media } = this.props;
    return (
      <Popper anchorEl={anchorEl} open={open} placement="right">
        <Paper>
          <Typography variant="headline">
            {path ? path.properties.nome : ''}
          </Typography>
          {candidato ? (
            <div className={classes.candidatoChart}>
              {candidato.avatar ? (
                <Avatar src={candidato.avatar} />
              ) : (
                <Avatar style={{ backgroundColor: candidato.partido.cor }}>
                  {candidato.nome.match(/[A-Z]/g)}
                </Avatar>
              )}
              <div style={{ width: '100%', position: 'relative' }}>
                {candidato.nome} ({candidato.numero})
                <div style={{ display: 'flex', flexDirection: 'row' }}>
                  <div
                    className={classes.candidatoBar}
                    style={{
                      backgroundColor: candidato.partido.cor,
                      width: `${media}%`,
                    }}
                  />
                  <span style={{ marginLeft: '5px', fontWeight: 'bold' }}>
                    {media.formatPercent()}
                  </span>
                </div>
              </div>
            </div>
          ) : (
            ''
          )}
        </Paper>
      </Popper>
    );
  }
}

export default withStyles(styles)(MajoritarioPopper);



// WEBPACK FOOTER //
// ./src/components/mapas/MajoritarioPopper.js